<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/TURISMO.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar profesionales en Turismo capaces de emprender, gestionar e innovar proyectos turísticos sustentables
        donde la calidad será su característica principal, acordes con las necesidades y las tendencias globales que
        este sector demanda, con sentido ético y respeto a la integridad del patrimonio natural y cultural, para el
        desarrollo y crecimiento óptimo del turismo.
    </div>



    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
        Formar profesionistas altamente competitivos con excelencia académica con principios y valores éticos en todos
        sus aspectos: cultural, administrativo, social, económico y turístico, para enfrentar eficiente y eficazmente
        los retos que presenta la actividad turística..
    </div>

    <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
        Ser líder en la formación de profesionales innovadores que respondan a las necesidades del quehacer turístico,
        para el desarrollo local, regional y nacional.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

<!--       <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditación
        </button>
      </li> -->

      <!--       <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Atributos de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">
          5. Acreditación
        </button>
      </li>  -->
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <ul>

          <li>1. Sensibilidad para la preservación del medio ambiente</li>
          <li>2. Interés por conocer la diversidad cultural</li>
          <li>3. Interés por el desarrollo y bienestar de las comunidades</li>
          <li>4. Conocimientos básicos en geografía, cultural general, historia</li>
          <li>5. Habilidades de emprendedurismo, trabajo colaborativo, creatividad, facilidad de adaptación a diferentes
            entornos.</li>
          <li>6. Interés en técnicas básicas de supervivencia.</li>
          <li>7. Interés por el fomento al desarrollo sostenible.</li>
          <li>8. Aptitudes para comunicar incluyendo otros idiomas y para el manejo de relaciones humanas.</li>
          <li>9. Actitud de liderazgo, de iniciativa y creatividad de servicio y de excelencia en la prestación del
            servicio.</li>
          <li>10. Innovación en las diferentes áreas prácticas del ámbito turístico. Promueve el desarrollo sustentable
            en el turismo fomentando el respeto a la cultura y la naturaleza con un compromiso ético. </li>

        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">

        <ul>
          <li>1. Promueve el desarrollo sustentable en el turismo fomentando el respeto a la cultura y la naturaleza con
            un compromiso ético.</li>
          <li>2. Evalúa y aplica planes, programas y proyectos turísticos para el desarrollo integral de las comunidades
            receptoras.</li>
          <li>3. Reconoce el fenómeno turístico identificando los indicadores de orden social, para coadyuvar al aumento
            de la calidad de la oferta turística.</li>
          <li>4. Preserva la cultura nacional e internacional respetando su identidad.</li>
          <li>5. Elabora un plan de negocios para la creación de empresas turísticas.</li>
          <li>6. Valora la riqueza ecológica para la prestación de servicios turísticos.</li>
          <li>7. Administra recursos humanos, materiales, técnicos y financieros de empresas turísticas.</li>
          <li>8. Conoce el marco legal, para garantizar el funcionamiento del sistema turístico fortaleciendo la
            seguridad en su entorno.</li>
          <li>9. Aplica el uso de las tecnologías de la información y comunicación (TIC´S) para lograr la eficiencia en
            el desarrollo del sistema turístico.</li>
          <li>10. Analiza las nuevas tendencias para el desarrollo del sector turístico a nivel global.</li>
        </ul>
      </div>


      <!--       <div id="tab3" class="tab-pane fade">
        <ul>
           <h5>"Programa Acreditado por el Consejo de Acreditación de Ciencias Administrativas, Contables y Afines, A.C. con vigencia hasta Abril de 2028"

</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/caceca.png" alt="Información de la carrera" class="tab-image">
        </div>
        </ul>
       

          </div>
 -->

      <!--  <div id="tab4" class="tab-pane fade">
        
        <ul>
          <li>Identifica, formula y resuelve problemas de ingeniería computacional aplicando los principios de las ciencias básicas e ingeniería.</li>
          <li>Aplica metodologías para el análisis y diseño de soluciones tecnológicas que cumplen las necesidades especificadas.</li>
          <li>Desarrolla y conduce proyectos de tecnología computacional y/o científicos para analizar e interpretar datos y utilizar el juicio ingenieril para la toma de decisiones y análisis de resultados.</li>
          <li>Comunica y colabora efectivamente con equipos multidisciplinarios que le permitan analizar, planificar y desarrollar proyectos de tecnología computacional</li>
          <li>Reconoce sus responsabilidades éticas y profesionales al generar soluciones computacionales, en el contexto global, económico, ambiental y social.</li>
          <li>Reconoce la necesidad de actualización en tendencias del ámbito tecnológico que le permita tener la habilidad para localizar, evaluar, integrar y aplicar este conocimiento adecuadamente</li>
          <li>Dirige y/o participa en equipos de trabajo para analizar, planear, gestionar, y ejecutar tareas para el cumplimiento de metas de proyectos de tecnología computacional.</li>
        </ul>
      </div> 


           <div id="tab5" class="tab-pane fade">
              <h5>"Programa Acreditado por el Consejo de Acreditación de la Enseñanza de la Ingeniería con vigencia hasta Diciembre de 2028"</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/logo cacei.jpg" alt="Información de la carrera" class="tab-image">

     </div>  -->

    </div>

  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1PlKRP4SMRZuaI1bfq50dIis8i6cNkTur" target="_blank" class="doc-link">
      ■ DOCUMENTACIÓN LICENCIATURA EN TURISMO
    </a>
  </div>

  <hr>


  <div class="btn-section">
    <a href="assets/reticulas/Reticula Licenciatura en Turismo TECNM.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Lic. Yazmin Estrada Chan</p>
        <p>E-mail: <a href="mailto:divisionturismo@itsescarcega.edu.mx">divisionturismo@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821293235 </P>
      </div>

      <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Elsy Guadalupe García Gomez</p>
        <p>E-mail: <a href="mailto:coordinacionturismo@itsescarcega.edu.mx">coordinacionturismo@itsescarcega.edu.mx</a></p>
         <p> Telefono:9821174005</p> 
      </div>

    </div>

  </section>

</div>